<template>
  <div class="like">
    <ul class="font14">
      <li class="rac" @click="toDetail"><span class="showE">金属非金属矿山企业主要负责人(露天矿山)</span> <span>03-14 07:00</span></li>  
    </ul>
  </div>
</template>

<script>
export default {
    data() {
        return {
            activeNames: ['1']
        }
    },
    methods: {
      toDetail() {
        this.$router.push('/index/likeD')
      }
    }
};
</script>

<style lang="less" scoped>
.like {
  ul {
    padding-top: 15px;
    li {
      width: 100%;
      box-sizing: border-box;
      padding: 10px 10px;
      border-bottom: 1px solid #ccc;
      & > span {
        &:first-child {
          max-width: 70%;
        }
      }
    }
  }
}
</style>